import { prototypeSources } from "@/mocks/prototype";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function PrototypeSection() {
  return (
    <section id="prototype" className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="故事原型"
            title="潘金莲的故事原型，来自两部小说"
            desc="几乎所有潘金莲电影的源头，都可以追溯到《水浒传》与《金瓶梅》。同一段人物关系，在两部作品里被写得截然不同，这也决定了后世改编的两条基本路径。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <Reveal className="lg:col-span-5">
            <div className="relative w-full h-[280px] md:h-[420px] lg:h-full lg:min-h-[520px] rounded-lg overflow-hidden bg-secondary-100">
              <img
                src="https://readdy.ai/api/search-image?query=Ancient%20Chinese%20thread-bound%20book%20and%20ink%20brush%20resting%20on%20aged%20parchment%20scroll%20with%20faint%20calligraphy%2C%20warm%20amber%20candlelight%2C%20ink-wash%20texture%2C%20dark%20wooden%20desk%2C%20stylized%20artistic%20illustration%2C%20deep%20shadows%2C%20muted%20crimson%20accents&width=800&height=900&seq=panjinlian-proto&orientation=portrait"
                alt="古籍、毛笔与泛黄书页，象征潘金莲故事的两部小说源头"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent p-5">
                <p className="font-heading text-sm md:text-base text-background-50 leading-relaxed">
                  从一部小说的配角，到另一部小说的主角，人物的命运被彻底改写。
                </p>
              </div>
            </div>
          </Reveal>

          <div className="lg:col-span-7 space-y-5">
            {prototypeSources.map((source, idx) => (
              <Reveal key={source.work} delay={idx * 80}>
                <article className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
                  <div className="flex items-start gap-4">
                    <span className="shrink-0 w-10 h-10 flex items-center justify-center rounded-md bg-primary-500/10 font-heading text-lg font-bold text-primary-600">
                      {idx + 1}
                    </span>
                    <div>
                      <div className="flex flex-wrap items-center gap-2">
                        <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
                          {source.work}
                        </h3>
                        <span className="rounded-full bg-secondary-100 px-3 py-0.5 font-label text-xs text-secondary-900">
                          {source.role}
                        </span>
                      </div>
                      <p className="mt-3 text-sm md:text-[15px] leading-relaxed text-foreground-700">
                        {source.text}
                      </p>
                      <ul className="mt-4 flex flex-wrap gap-2">
                        {source.points.map((p) => (
                          <li
                            key={p}
                            className="rounded-full bg-background-200/70 px-3 py-1 font-label text-xs text-foreground-700"
                          >
                            {p}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}